import {h} from 'vue';
import type {IconProps, IconSet} from 'vuetify';
import {mdiIconMap} from './mdi-icons';

// Custom Vuetify icon set: resolves the `mdi-*` names already used across the
// app (via client-core `Icons`, raw strings and Vuetify aliases) to tree-shaken
// SVG paths from @mdi/js — no `@mdi/font` webfont download (ticket T00HNMV7BCIH).
// Registered under the name `mdi`, so every existing call site keeps working
// unchanged.
export const mdiSvgIconSet: IconSet = {
    component: (props: IconProps) => {
        const path = typeof props.icon === 'string' ? mdiIconMap[props.icon] ?? '' : '';
        return h(
            props.tag,
            h(
                'svg',
                {
                    class: 'v-icon__svg',
                    xmlns: 'http://www.w3.org/2000/svg',
                    viewBox: '0 0 24 24',
                    role: 'img',
                    'aria-hidden': 'true',
                },
                [h('path', {d: path})]
            )
        );
    },
};
